var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content row-flex-start",staticStyle:{"width":"100%","height":"400px","ovorflow-x":"auto"}},[_c('div',{staticClass:"left_map",attrs:{"id":"left_map"},on:{"click":_vm.showChinaMap}}),_c('div',{staticClass:"right_opetate row-center",attrs:{"id":"right_opetate"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }